export const linkBg = '#e8eaee';
export const lightText = '#90949c';
export const headlineColor = '#1C2028';
export const descriptionColor = '#464950';
export const displayUrlColor = descriptionColor;
export const ctaColor = descriptionColor;
export const ctaBorder = '#444950';
export const darkText = '#1d2129';
export const headBg = '#fff';
export const ig_tag = '#003569';
export const fb_tag = '#576b95';
export const teads_tag = '#03A9F4';

export const typography = {
  primary: {
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#262626',
  },
  secondary: {
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
    color: '#262626',
    fontSize: '12px',
    lineHeight: '15px',
  },
};
